export default __webpack_public_path__ + "static/063-c4e64b949ae13de284cba699ef0dc40c.jpg";